import { Heading } from '@cinch-labs/design-system'
import { StoryblokRenderer } from '@cinch-nx/storyblok-utils'
import { SbBlokData } from '@storyblok/react'
import React from 'react'

import { landingStoryblokComponents } from '../../storyblok-renderer-map'
import styles from './highlights-section.module.css'

export interface HighlightsSectionProps {
  title: string
  highlights: SbBlokData[]
}

export const HighlightsSection: React.FC<HighlightsSectionProps> = ({
  title,
  highlights,
}) => (
  <div className={styles.container}>
    {title && (
      <div className={styles.heading}>
        <Heading element="h2" className={styles.title}>
          {title}
        </Heading>
      </div>
    )}
    {highlights?.length > 0 && (
      <div className={styles.cardsWrapper}>
        <StoryblokRenderer
          block={highlights}
          components={landingStoryblokComponents}
        />
      </div>
    )}
  </div>
)
